'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('../layout');

exports["default"] = _layout.Col;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/col/index.js
 ** module id = 554
 ** module chunks = 0
 **/